import { EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import {
  SezioneEsitiLiquidatiAdapter
} from '../components/fascicolo/esiti-add-liquidati/sezione-esiti-liquidati-adapter';
import { Controparte } from '../models/controparte';
import { Esito } from '../models/esito';
import { FascicoloFull } from '../models/fascicolo/fascicolo-full';
import { Liquidato } from '../models/liquidato';
import { SezioneEconomica } from '../models/sezioni/sezione-economica';
import { SezioneEsitiFull } from '../models/sezioni/sezione-esiti-full';
import { Cpa } from '../models/tipologiche/cpa';
import { Iva } from '../models/tipologiche/iva';
import { SoggettoPratica } from '../models/tipologiche/soggetto-pratica';
import { TipoLiquidato } from '../models/tipologiche/tipo-liquidato';
import { NumericOperationManager } from '../utils/numeric-operation-manager';
import { BaseForm } from './base-Form';
import { AltraParte } from '../models/altraparte';
import { LegaleIncaricato } from '../models/legale-incaricato';
import { SezioneAltrePartiResponse } from '../models/dto/sezione-altre-parti-response';
import { SezioneLegaliResponse } from '../models/dto/sezione-legali-response';

export abstract class EsitiLiquidatiFormComponent extends BaseForm {

  onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();

  request: Liquidato;
  liquidatoForm: FormGroup;
  fascicolo: FascicoloFull;
  sezione: SezioneEsitiFull;
  esito: Esito;
  isViewTerzoPignorato: boolean = false;
  urlReadSezioneEconomica: string;
  urlReadClassificazioni: string;
  idSezioneClassificazioni: string;
  //tipologiche
  contropartiOptionsList: Controparte[] = [];
  controparteOptions: Controparte[] = [];
  societaOptions: SoggettoPratica[] = [];
  altreParti: AltraParte[] = [];
  legali: LegaleIncaricato[] = [];
  tuttiISoggetti: (Controparte | AltraParte | LegaleIncaricato)[] = [];
  tuttiISoggettiInit: (Controparte | AltraParte | LegaleIncaricato)[] = [];
  ivaOptions: Iva[] = [];
  cpaOptions: Cpa[] = [];
  tipiLiquidato: TipoLiquidato[] = [];
  tipoLiquidatoSel: TipoLiquidato = null;
  //
  sezioneEconomica: SezioneEconomica;
  indexLiquidato: number = null;
  //flag
  isImportiTotali: boolean = false;
  isRipartizione: boolean = false;
  isModifica: boolean = false;
  isDefault: boolean = false;
  isModificaSezioneLiquidati: boolean = false;
  isEliminaRipartizione: boolean = false;
  //calcoli
  cpaPerc: number;
  ivaPerc: number;
  //array liquidati
  arrayLiquidati: Liquidato[] = [];
  liquidatiReset: Liquidato[] = [];

  resetRipartizione: boolean = false;

  listaLiquidati: any;

  idSezioneAltreParti: string;
  urlSezioneAltreParti: string;
  idSezioneLegali: string;
  urlSezioneLegali: string;
  selectedControlName:string;



  abstract getLiquidato(): Liquidato;
  abstract getRequest(esito: Esito, request: Liquidato, isImportiTotali: boolean, listaLiquidati, isModificaSezioneLiquidati: boolean);
  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService) {
    super();
  }

  initRequest() {
    this.request = new SezioneEsitiLiquidatiAdapter(this.getLiquidato()).liquidato;
    this.selectedControlName = this.getSelectedControlName();
    //this.ricalcolaImporti(null, null);
  }

  private getSelectedControlName(): string {
    if (this.request.controparte) return 'controparte';
    if (this.request.altraParte) return 'altraparte';
    if (this.request.legaleIncaricato) return 'legaleIncaricato';
    return '';
  }

  createForm() {
    this.resetVariabili();
    this.initRequest();
    this.resetTipologiche();
    this.tipoLiquidatoSel = null;
    this.liquidatoForm = this.campiForm.group({
      //controparte: [this.request.controparte],
      societa: [this.request.societa],
      ripartizioneEqua: [this.request.ripartizioneEqua],
      note: [this.request.note],
      importo: [this.request.importoLiquidato.importo],
      interessi: [this.request.importoLiquidato.interessi],
      //sanzioni: [this.request.importoLiquidato.sanzioni],
      compenso: [this.request.costoGestioneLiquidato.compenso],
      cpa: [this.request.costoGestioneLiquidato.cpa],
      iva: [this.request.costoGestioneLiquidato.iva],
      flagRitenutaAcconto: [this.request.costoGestioneLiquidato.flagRitenutaAcconto],
      speseRegistrazione: [this.request.altroImportoLiquidato.speseRegistrazione],
      contributoUnificato: [this.request.altroImportoLiquidato.contributoUnificato],
      altroImporto: [this.request.altroImportoLiquidato.altroImporto],
      rimborsoTerzoPignorato: [this.request.altroImportoLiquidato.rimborsoTerzoPignorato],
      importiTotali: [this.isImportiTotali],
      speseGenerali: [this.request.costoGestioneLiquidato.speseGenerali],
      speseLiquidate: [this.request.costoGestioneLiquidato.speseLiquidate],
      irap: [this.request.costoGestioneLiquidato.irap],
      oneriRiflessi:[this.request.costoGestioneLiquidato.oneriRiflessi],
      speseMarcheNotifica: [this.request.costoGestioneLiquidato.speseMarcheNotifica],
      art96CPC: [this.request.costoGestioneLiquidato.art96CPC],
      f23: [this.request.costoGestioneLiquidato.f23],
      risarcimento: [this.request.costoGestioneLiquidato.risarcimento],
      tipoLiquidato: [this.tipoLiquidatoSel, Validators.required],
      [this.selectedControlName]: new FormControl(''),
      daEliminare: [this.request.daEliminare]
    });
    this.liquidatoForm.get('cpa')?.valueChanges.subscribe(val => {
        this.ricalcolaImporti(null, 'cpa');
    });

    this.liquidatoForm.get('iva')?.valueChanges.subscribe(val => {
        this.ricalcolaImporti(null, 'iva');
    });
  }


  totaleImportiRipartizioneEqua(): Number {
    let totale: number = 0;
    if (this.esito.liquidati.length > 0) {
      this.esito.liquidati.forEach(element => totale += element.ripartizioneEqua ? this.totaleImportiLiquidato(element) : 0);
    }
    return totale;
  }


  inizializzaModifica() {
    this.tipoLiquidatoSel = this.arrayLiquidati[0].tipoLiquidato; //è lo stesso per tutti
    if (this.arrayLiquidati && (this.arrayLiquidati[0].controparte || this.arrayLiquidati[0].altraParte || this.arrayLiquidati[0].legaleIncaricato) && !this.arrayLiquidati[0].ripartizioneEqua) { //controllo che non sono ripartizione o importi tot
      this.isDefault = true;
    } else {
      if (this.arrayLiquidati && (this.arrayLiquidati[0].controparte || this.arrayLiquidati[0].altraParte || this.arrayLiquidati[0].legaleIncaricato) && this.arrayLiquidati[0].ripartizioneEqua === true) { //sono ripartizione equa
        this.isRipartizione = true;
      } else { //sono importi totali
        this.isImportiTotali = true;
        this.request = JSON.parse(JSON.stringify(new SezioneEsitiLiquidatiAdapter(this.arrayLiquidati[0]).liquidato));
        this.ricalcolaImporti(null, null);
        this.liquidatoForm = this.campiForm.group({
          //controparte: [this.request.controparte],
          societa: [this.request.societa],
          ripartizioneEqua: [this.request.ripartizioneEqua],
          note: [this.request.note],
          importo: [this.request.importoLiquidato.importo],
          interessi: [this.request.importoLiquidato.interessi],
          //sanzioni: [this.request.importoLiquidato.sanzioni],
          compenso: [this.request.costoGestioneLiquidato.compenso],
          cpa: [this.request.costoGestioneLiquidato.cpa],
          iva: [this.request.costoGestioneLiquidato.iva],
          flagRitenutaAcconto: [this.request.costoGestioneLiquidato.flagRitenutaAcconto],
          speseRegistrazione: [this.request.altroImportoLiquidato.speseRegistrazione],
          contributoUnificato: [this.request.altroImportoLiquidato.contributoUnificato],
          altroImporto: [this.request.altroImportoLiquidato.altroImporto],
          rimborsoTerzoPignorato: [this.request.altroImportoLiquidato.rimborsoTerzoPignorato],
          importiTotali: [this.isImportiTotali],
          speseGenerali: [this.request.costoGestioneLiquidato.speseGenerali],
          tipoLiquidato: [this.tipoLiquidatoSel, Validators.required],
          speseLiquidate: [this.request.costoGestioneLiquidato.speseLiquidate],
          irap: [this.request.costoGestioneLiquidato.irap],
          oneriRiflessi:[this.request.costoGestioneLiquidato.oneriRiflessi],
          speseMarcheNotifica: [this.request.costoGestioneLiquidato.speseMarcheNotifica],
          art96CPC: [this.request.costoGestioneLiquidato.art96CPC],
          f23: [this.request.costoGestioneLiquidato.f23],
          risarcimento: [this.request.costoGestioneLiquidato.risarcimento],
          [this.selectedControlName]: new FormControl(''),
          daEliminare: [this.request.daEliminare]
        });
      }
    }

  }

  totaleImportiLiquidato(liquidato: Liquidato): number {
    let totale = 0;
    totale += Number(liquidato.importoLiquidato.importo) + Number(liquidato.importoLiquidato.interessi);
    let cpaImporto = liquidato.costoGestioneLiquidato.cpa ? Number(liquidato.costoGestioneLiquidato.compenso) * (liquidato.costoGestioneLiquidato.cpa.valore / 100) : 0;
    let ivaImporto = liquidato.costoGestioneLiquidato.iva ? Number(liquidato.costoGestioneLiquidato.compenso) * (liquidato.costoGestioneLiquidato.iva.valore / 100) : 0;
    let irapImporto = liquidato.costoGestioneLiquidato.irap ? Number(liquidato.costoGestioneLiquidato.compenso) * (liquidato.costoGestioneLiquidato.irap / 100) : 0;
    let oneriRiflessiImporto = liquidato.costoGestioneLiquidato.oneriRiflessi ? Number(liquidato.costoGestioneLiquidato.compenso) * (liquidato.costoGestioneLiquidato.oneriRiflessi / 100) : 0;
    let ritenutaAcconto = liquidato.costoGestioneLiquidato.flagRitenutaAcconto ? Number(liquidato.costoGestioneLiquidato.compenso) * 0.2 : 0;
    totale += (Number(liquidato.costoGestioneLiquidato.compenso) + cpaImporto + ivaImporto + irapImporto + oneriRiflessiImporto ) - ritenutaAcconto;
    totale += Number(liquidato.altroImportoLiquidato.contributoUnificato) + Number(liquidato.altroImportoLiquidato.speseRegistrazione) + Number(liquidato.altroImportoLiquidato.altroImporto);
    return totale;
  }


  isRipartizioneEqua(liquidati: Liquidato[]): boolean {
    return !!liquidati.find(element => !!element.ripartizioneEqua);
  }

  populateSelect(urlSezioneAltreParti:string, idSezioneAltreParti: string, 
    urlSezioneLegali :string, idSezioneLegali:string) {
    this.contropartiOptionsList = this.getListContropartiEsito();
    if (this.arrayLiquidati && this.arrayLiquidati.length > 0) {
      this.arrayLiquidati.forEach(liquidato => {
        const idControparte = liquidato?.controparte?.id;
        if (idControparte != null) {
          const idx = this.contropartiOptionsList.findIndex(el => el?.id === idControparte);
          if (idx >= 0) {
            this.contropartiOptionsList.splice(idx, 1);
          }
        }
      });
    }
    this.updateTuttiISoggetti();
    if (this.altreParti.length === 0) {
      if(idSezioneAltreParti){
        this.operationService.readSezione(urlSezioneAltreParti, idSezioneAltreParti).subscribe(response => {
          const altrePartiResponse = (<SezioneAltrePartiResponse>response).sezione.altreParti;
          if (altrePartiResponse && altrePartiResponse.length > 0) {
            this.processSoggettiTerzi(altrePartiResponse);
            this.updateTuttiISoggetti();
          }
        });
      }
    }
  
    if (this.legali.length === 0) {
      if(idSezioneLegali){
        this.operationService.readSezione(urlSezioneLegali, idSezioneLegali).subscribe(response => {
          const legaliResponse = (<SezioneLegaliResponse>response).sezione.legaliIncaricati;
          if (legaliResponse && legaliResponse.length > 0) {
            this.processLegali(legaliResponse);
            this.updateTuttiISoggetti();
          }
        });
      }
    }
    if (this.ivaOptions.length === 0) {
      this.helpers.getIva().subscribe(response => this.ivaOptions = response);
    }
    if (this.cpaOptions.length === 0) {
      this.helpers.getCpa().subscribe(response => this.cpaOptions = response);
    }
    if (this.tipiLiquidato.length === 0) {
      this.helpers.getTipiLiquidato().subscribe(response => {
        this.tipiLiquidato = response.tipologiche;
        //this.tipoLiquidatoSel = this.tipiLiquidato[0];
      });
    }
  }

  processSoggettiTerzi(altreparti: AltraParte[]) {
    this.altreParti = altreparti.sort((leftSide, rigthSide): number => {
      if (leftSide.parte.cognome < rigthSide.parte.cognome) { return -1; }
      if (leftSide.parte.cognome > rigthSide.parte.cognome) { return 1; }
      return 0;
    });
  }

  processLegali(legali: LegaleIncaricato[]) {
    this.legali = legali.sort((leftSide, rigthSide): number => {
      if (leftSide.legale.cognome < rigthSide.legale.cognome) { return -1; }
      if (leftSide.legale.cognome > rigthSide.legale.cognome) { return 1; }
      return 0;
    });
  }

  updateTuttiISoggetti() {
    this.tuttiISoggetti = [...this.contropartiOptionsList, ...this.altreParti, ...this.legali]; 
    this.tuttiISoggettiInit = this.tuttiISoggetti;
    if (this.isModificaSezioneLiquidati && this.isEliminaRipartizione === false) {
      this.tuttiISoggetti = this.filtraSoggettiSelezionati(this.tuttiISoggetti);
    }
    this.isEliminaRipartizione = false;
    return this.tuttiISoggetti;   
  }

  private filtraSoggettiSelezionati(soggetti: any[]): any[] {
    return soggetti.filter(soggetto => 
      !this.arrayLiquidati.some(liquidato => 
        (liquidato.controparte && liquidato.controparte.id === soggetto.id) ||
        (liquidato.altraParte && liquidato.altraParte.id === soggetto.id) ||
        (liquidato.legaleIncaricato && liquidato.legaleIncaricato.id === soggetto.id)
      )
    );
  }
  

  private isControparte(item: any): item is Controparte {
    return item && 'legaleControparte' in item;
  }



  private isAltraParte(item: any): item is AltraParte {
    return item && 'controparte' in item;
  }

  private isLegaleIncaricato(item: any): item is LegaleIncaricato {
    return 'legale' in item;
  }

 
  handleReturn(event: any) {
    if (this.isControparte(event)) {
      this.request.controparte = event;
    }
    else if(this.isAltraParte(event)){
      this.request.altraParte = event;
    }
    else if(this.isLegaleIncaricato(event)){
      this.request.legaleIncaricato = event;
    }
  }

  onChangeFlag(event) {
    this.initRequest();
    this.arrayLiquidati = [];
    this.selectedControlName = null; 
    this.liquidatoForm.get('selectedControlName')?.setValue(null);
  }

  checkIsRipartizioneEqua() {
    if (this.arrayLiquidati.length > 0 && this.arrayLiquidati.findIndex(el => el.ripartizioneEqua === true) != -1) return true;
    else return false
  }

  ripartizioneEquaMod(){
    if (this.liquidatiReset.length > 0 && this.liquidatiReset.findIndex(el => el.ripartizioneEqua === true) != -1) return true;
    else return false
  }

  ricalcolaImporti(event: any, tipoPerc: string) {
    let perc = 0;
    if (event && event.target && event.target.selectedIndex) {
        let percId = event.target.selectedIndex;
        perc = event.target.options[percId]?.label ?? 0;
        switch (tipoPerc) {
            case 'cpa': this.cpaPerc = perc; break;
            case 'iva': this.ivaPerc = perc; break;
        }
    } else {
        this.cpaPerc = this.request.costoGestioneLiquidato.cpa?.valore ?? 0;
        this.ivaPerc = this.request.costoGestioneLiquidato.iva?.valore ?? 0;
    }
  }

  addLiquidato() {
    this.request.tipoLiquidato = this.tipoLiquidatoSel;
    if (!this.isImportiTotali && !this.isRipartizione) {
        // Rimuovo i soggetti aggiunti
        if (this.request.controparte && this.request.controparte.id) {
            this.tuttiISoggetti = this.tuttiISoggetti.filter(el => el.id != this.request.controparte.id);
        }
        if (this.request.altraParte && this.request.altraParte.id) {
            this.tuttiISoggetti = this.tuttiISoggetti.filter(el => el.id != this.request.altraParte.id);
        }
        if (this.request.legaleIncaricato && this.request.legaleIncaricato.id) {
            this.tuttiISoggetti = this.tuttiISoggetti.filter(el => el.id != this.request.legaleIncaricato.id);
        }
    } else {
        if (this.isRipartizione) {
            this.ripartizioneEquaLiquidati();
            this.isModifica = false;
        }
    }
    if (!this.isModifica && !this.isRipartizione) { //l'array dei liquidati nel caso delle ripartizioni viene popolato in ripartizioneEquaLiquidati
        this.arrayLiquidati.push(this.request);
    }  else { 
      if (this.isModifica && !this.isRipartizione) { //cerco il vecchio liquidato e lo sostituisco con il nuovo
      let index = -1;

          if (this.request.controparte && this.request.controparte.id) {
              index = this.arrayLiquidati.findIndex(liquidato => 
                  liquidato.controparte && liquidato.controparte.id === this.request.controparte.id);
          } else if (this.request.altraParte && this.request.altraParte.id) {
              index = this.arrayLiquidati.findIndex(liquidato => 
                  liquidato.altraParte && liquidato.altraParte.id === this.request.altraParte.id);
          } else if (this.request.legaleIncaricato && this.request.legaleIncaricato.id) {
              index = this.arrayLiquidati.findIndex(liquidato => 
                  liquidato.legaleIncaricato && liquidato.legaleIncaricato.id === this.request.legaleIncaricato.id);
          }

          if (index !== -1) {
              this.arrayLiquidati[index] = { ...this.request };
          }
          this.isModifica = false;
        }
    }
    console.log(this.arrayLiquidati);
    this.initRequest();
  }

  modificaSingoloLiquidato(liquidato: Liquidato) {
    this.resetContropartiOptions(liquidato);
    this.request = JSON.parse(JSON.stringify(new SezioneEsitiLiquidatiAdapter(liquidato).liquidato));
    this.isModifica = true;
    this.ricalcolaImporti(null, null);
  }

  resetContropartiOptions(liquidato: Liquidato) {
    if (liquidato.controparte && liquidato.controparte.id) {
      this.tuttiISoggetti.push(this.controparteOptions[this.controparteOptions.findIndex(el => el.id === liquidato.controparte.id)]);
    }
    else if (liquidato.altraParte && liquidato.altraParte.id) {
      this.tuttiISoggetti.push(this.altreParti[this.altreParti.findIndex(el => el.id === liquidato.altraParte.id)]);
    }
    else if (liquidato.legaleIncaricato && liquidato.legaleIncaricato.id) {
      this.tuttiISoggetti.push(this.legali[this.legali.findIndex(el => el.id === liquidato.legaleIncaricato.id)]);
    }     
  }

  modificaRipartizione() {
    this.isRipartizione = true;
    this.isModifica = true;
    // inizializzo a 0 per effettuare la somma;
   if(this.arrayLiquidati[0].id && this.arrayLiquidati[0].ripartizioneEqua){
    this.request.importoLiquidato.importo = 0;
    this.request.importoLiquidato.interessi = 0;
    //this.request.importoLiquidato.sanzioni = 0;
    this.request.costoGestioneLiquidato.compenso = 0;
    this.request.costoGestioneLiquidato.speseGenerali = 0;
    this.request.costoGestioneLiquidato.speseLiquidate = 0;
    this.request.costoGestioneLiquidato.speseMarcheNotifica = 0;
    this.request.costoGestioneLiquidato.irap = 0;
    this.request.costoGestioneLiquidato.oneriRiflessi = 0;
    this.request.costoGestioneLiquidato.f23 = 0;
    this.request.costoGestioneLiquidato.art96CPC = 0;
    this.request.costoGestioneLiquidato.risarcimento = 0;
    this.request.altroImportoLiquidato.speseRegistrazione = 0;
    this.request.altroImportoLiquidato.contributoUnificato = 0;
    this.request.altroImportoLiquidato.altroImporto = 0;
    this.request.altroImportoLiquidato.rimborsoTerzoPignorato = 0;
    this.arrayLiquidati.forEach(el => {
      this.request.dataLiquidato = el.dataLiquidato;
      this.request.tipoLiquidato = el.tipoLiquidato;
      this.request.ripartizioneEqua = el.ripartizioneEqua;
      if(this.request.controparte){
        this.request.controparte = el.controparte;
      }
      if(this.request.altraParte){
        this.request.altraParte = el.altraParte;
      }
      if(this.request.legaleIncaricato){
        this.request.legaleIncaricato = el.legaleIncaricato;
      } 
      this.request.importoLiquidato.importo += (el.importoLiquidato.importo) ? (el.importoLiquidato.importo) : 0;
      this.request.importoLiquidato.importo = Number(this.request.importoLiquidato.importo.toFixed(2));
      this.request.costoGestioneLiquidato.speseLiquidate += (el.costoGestioneLiquidato.speseLiquidate) ? (el.costoGestioneLiquidato.speseLiquidate) : 0;
      this.request.costoGestioneLiquidato.irap += (el.costoGestioneLiquidato.irap) ? (el.costoGestioneLiquidato.irap) : 0;
      this.request.costoGestioneLiquidato.oneriRiflessi += (el.costoGestioneLiquidato.oneriRiflessi) ? (el.costoGestioneLiquidato.oneriRiflessi) : 0;
      this.request.costoGestioneLiquidato.speseMarcheNotifica += (el.costoGestioneLiquidato.speseMarcheNotifica) ? (el.costoGestioneLiquidato.speseMarcheNotifica) : 0;
      this.request.costoGestioneLiquidato.art96CPC += (el.costoGestioneLiquidato.art96CPC) ? (el.costoGestioneLiquidato.art96CPC) : 0;
      this.request.costoGestioneLiquidato.f23 += (el.costoGestioneLiquidato.f23) ? (el.costoGestioneLiquidato.f23) : 0;
      this.request.costoGestioneLiquidato.risarcimento += (el.costoGestioneLiquidato.risarcimento) ? (el.costoGestioneLiquidato.risarcimento) : 0; 
      this.request.costoGestioneLiquidato.speseGenerali += (el.costoGestioneLiquidato.speseGenerali) ? (el.costoGestioneLiquidato.speseGenerali) : 0;
      this.request.importoLiquidato.interessi += (el.importoLiquidato.interessi) ? (el.importoLiquidato.interessi) : 0;
      //this.request.importoLiquidato.sanzioni += (el.importoLiquidato.sanzioni) ? (el.importoLiquidato.sanzioni) : 0;
      this.request.costoGestioneLiquidato.iva = el.costoGestioneLiquidato.iva;
      this.request.costoGestioneLiquidato.cpa = el.costoGestioneLiquidato.cpa;
      this.request.costoGestioneLiquidato.flagRitenutaAcconto = el.costoGestioneLiquidato.flagRitenutaAcconto;
      this.request.costoGestioneLiquidato.compenso += (el.costoGestioneLiquidato.compenso) ? (el.costoGestioneLiquidato.compenso) : 0;
      this.request.altroImportoLiquidato.speseRegistrazione += (el.altroImportoLiquidato.speseRegistrazione) ? (el.altroImportoLiquidato.speseRegistrazione) : 0
      this.request.altroImportoLiquidato.contributoUnificato += (el.altroImportoLiquidato.contributoUnificato) ? (el.altroImportoLiquidato.contributoUnificato) : 0;
      this.request.altroImportoLiquidato.altroImporto += (el.altroImportoLiquidato.altroImporto) ? (el.altroImportoLiquidato.altroImporto) : 0;
      this.request.altroImportoLiquidato.rimborsoTerzoPignorato += (el.altroImportoLiquidato.rimborsoTerzoPignorato) ? (el.altroImportoLiquidato.rimborsoTerzoPignorato) : 0;
    })
   }else{
    this.arrayLiquidati.forEach(el => {
      this.request.dataLiquidato = el.dataLiquidato;
      this.request.tipoLiquidato = el.tipoLiquidato;
      this.request.ripartizioneEqua = el.ripartizioneEqua;
      if(this.request.controparte){
        this.request.controparte = el.controparte;
      }
      if(this.request.altraParte){
        this.request.altraParte = el.altraParte;
      }
      if(this.request.legaleIncaricato){
        this.request.legaleIncaricato = el.legaleIncaricato;
      }      
      this.request.importoLiquidato.importo = (el.importoLiquidato.importo) ? (el.importoLiquidato.importo) : 0;
      this.request.importoLiquidato.importo = Number(this.request.importoLiquidato.importo.toFixed(2));
      this.request.costoGestioneLiquidato.speseGenerali = (el.costoGestioneLiquidato.speseGenerali) ? (el.costoGestioneLiquidato.speseGenerali) : 0;
      this.request.costoGestioneLiquidato.speseLiquidate = (el.costoGestioneLiquidato.speseLiquidate) ? (el.costoGestioneLiquidato.speseLiquidate) : 0;
      this.request.costoGestioneLiquidato.irap = (el.costoGestioneLiquidato.irap) ? (el.costoGestioneLiquidato.irap) : 0;
      this.request.costoGestioneLiquidato.oneriRiflessi = (el.costoGestioneLiquidato.oneriRiflessi) ? (el.costoGestioneLiquidato.oneriRiflessi) : 0;
      this.request.costoGestioneLiquidato.f23 = (el.costoGestioneLiquidato.f23) ? (el.costoGestioneLiquidato.f23) : 0;
      this.request.costoGestioneLiquidato.speseMarcheNotifica = (el.costoGestioneLiquidato.speseMarcheNotifica) ? (el.costoGestioneLiquidato.speseMarcheNotifica) : 0;
      this.request.costoGestioneLiquidato.art96CPC = (el.costoGestioneLiquidato.art96CPC) ? (el.costoGestioneLiquidato.art96CPC) : 0;
      this.request.costoGestioneLiquidato.risarcimento = (el.costoGestioneLiquidato.risarcimento) ? (el.costoGestioneLiquidato.risarcimento) : 0;
      this.request.importoLiquidato.interessi = (el.importoLiquidato.interessi) ? (el.importoLiquidato.interessi) : 0;
      //this.request.importoLiquidato.sanzioni = (el.importoLiquidato.sanzioni) ? (el.importoLiquidato.sanzioni) : 0;
      this.request.costoGestioneLiquidato.iva = el.costoGestioneLiquidato.iva;
      this.request.costoGestioneLiquidato.cpa = el.costoGestioneLiquidato.cpa;
      this.request.costoGestioneLiquidato.flagRitenutaAcconto = el.costoGestioneLiquidato.flagRitenutaAcconto;
      this.request.costoGestioneLiquidato.compenso = (el.costoGestioneLiquidato.compenso) ? (el.costoGestioneLiquidato.compenso) : 0;
      this.request.altroImportoLiquidato.speseRegistrazione = (el.altroImportoLiquidato.speseRegistrazione) ? (el.altroImportoLiquidato.speseRegistrazione) : 0
      this.request.altroImportoLiquidato.contributoUnificato = (el.altroImportoLiquidato.contributoUnificato) ? (el.altroImportoLiquidato.contributoUnificato) : 0;
      this.request.altroImportoLiquidato.altroImporto = (el.altroImportoLiquidato.altroImporto) ? (el.altroImportoLiquidato.altroImporto) : 0;
      this.request.altroImportoLiquidato.rimborsoTerzoPignorato = (el.altroImportoLiquidato.rimborsoTerzoPignorato) ? (el.altroImportoLiquidato.rimborsoTerzoPignorato) : 0;
    })
   }
   this.ricalcolaImporti(null,null);    

    /*this.request.importoLiquidato.importo = 0;
    this.request.importoLiquidato.interessi = 0;
    this.request.importoLiquidato.sanzioni = 0;
    this.request.costoGestioneLiquidato.compenso = 0;
    this.request.altroImportoLiquidato.speseRegistrazione = 0;
    this.request.altroImportoLiquidato.contributoUnificato = 0;
    this.request.altroImportoLiquidato.altroImporto = 0;
    this.request.altroImportoLiquidato.rimborsoTerzoPignorato = 0;
    this.arrayLiquidati.forEach(el => {
      this.request.dataLiquidato = el.dataLiquidato;
      this.request.tipoLiquidato = el.tipoLiquidato;
      this.request.ripartizioneEqua = el.ripartizioneEqua;
      this.request.controparte = el.controparte;
      this.request.importoLiquidato.importo += (el.importoLiquidato.importo) ? (el.importoLiquidato.importo) : 0;
      this.request.importoLiquidato.interessi += (el.importoLiquidato.interessi) ? (el.importoLiquidato.interessi) : 0;
      this.request.importoLiquidato.sanzioni += (el.importoLiquidato.sanzioni) ? (el.importoLiquidato.sanzioni) : 0;
      this.request.costoGestioneLiquidato.iva = el.costoGestioneLiquidato.iva;
      this.request.costoGestioneLiquidato.cpa = el.costoGestioneLiquidato.cpa;
      this.request.costoGestioneLiquidato.flagRitenutaAcconto = el.costoGestioneLiquidato.flagRitenutaAcconto;
      this.request.costoGestioneLiquidato.compenso += (el.costoGestioneLiquidato.compenso) ? (el.costoGestioneLiquidato.compenso) : 0;
      this.request.altroImportoLiquidato.speseRegistrazione += (el.altroImportoLiquidato.speseRegistrazione) ? (el.altroImportoLiquidato.speseRegistrazione) : 0
      this.request.altroImportoLiquidato.contributoUnificato += (el.altroImportoLiquidato.contributoUnificato) ? (el.altroImportoLiquidato.contributoUnificato) : 0;
      this.request.altroImportoLiquidato.altroImporto += (el.altroImportoLiquidato.altroImporto) ? (el.altroImportoLiquidato.altroImporto) : 0;
      this.request.altroImportoLiquidato.rimborsoTerzoPignorato += (el.altroImportoLiquidato.rimborsoTerzoPignorato) ? (el.altroImportoLiquidato.rimborsoTerzoPignorato) : 0;*/

  }

  rimuoviRipartizione(){
     this.arrayLiquidati.forEach(el => el.ripartizioneEqua = false);
     this.isRipartizione = false;
     this.populateSelect(this.urlSezioneAltreParti, this.idSezioneAltreParti,this.urlSezioneLegali, this.idSezioneLegali);
  }

  eliminaRipartizione() {
    this.isEliminaRipartizione = true;
    this.resetForm(true);
    this.updateTuttiISoggetti(); 
  }

  save() {
    console.log(this.arrayLiquidati)
    //per importi totali
    if (this.isImportiTotali) {
      this.request.tipoLiquidato = this.tipoLiquidatoSel;
      this.request.dataLiquidato = new Date().getTime();
    }
    if (this.isImportiTotali && !this.isModificaSezioneLiquidati) { //se  non sono in modifica pusho direttamente la request
      this.arrayLiquidati.push(this.request)
    } else {
      if (this.isImportiTotali) {
        this.arrayLiquidati = [];
        this.arrayLiquidati.push(this.request)
      }
    }
    this.getRequest(this.esito, this.request, this.isImportiTotali, this.listaLiquidati, this.isModificaSezioneLiquidati);
  }


  getListContropartiEsito(): Controparte[] {
    let contropartiOptions = [];
    this.contropartiOptionsList = [];
    this.esito.dettagliEsito.forEach(dettaglio => {
      contropartiOptions.push(dettaglio.controparte);
      this.controparteOptions.push(dettaglio.controparte);
    });
    //this.onChangeImportiTotali(contropartiOptions.length==0 || this.insertedImportiTotali(this.esito));
    return contropartiOptions;
  }

  resetForm(isElimina?: boolean) {
    this.resetVariabili();
    this.initRequest();
    this.tuttiISoggetti = this.tuttiISoggettiInit;
    this.selectedControlName = null;
    //this.liquidatoForm.get('selectedControlName')?.setValue(null);
    if (this.liquidatiReset.length > 0 && !isElimina) {
      this.arrayLiquidati = this.esito.liquidati.map(liquidato=>{return liquidato});
      this.liquidatiReset = this.esito.liquidati.map(liquidato=>{return liquidato}); 
      this.inizializzaModifica();
    }
    this.populateSelect(this.urlSezioneAltreParti, this.idSezioneAltreParti,this.urlSezioneLegali, this.idSezioneLegali);
  }

  resetVariabili() {
    this.arrayLiquidati = [];
    this.controparteOptions = [];
    this.contropartiOptionsList = [];    
    this.isDefault = false;
    this.isImportiTotali = false;
    this.isRipartizione = false;
    this.isModifica = false;
  }

  resetTipologiche() {
    this.tipiLiquidato = [];
    this.controparteOptions = [];
    this.contropartiOptionsList = [];
    this.ivaOptions = [];
    this.cpaOptions = [];
  }

  eliminaLiquidato(liquidato: Liquidato) {
    this.resetContropartiOptions(liquidato);
    
    if (liquidato.controparte && liquidato.controparte.id) {
      const index = this.arrayLiquidati.findIndex(el => el.controparte && el.controparte.id === liquidato.controparte.id);
      if (index !== -1) {
          this.arrayLiquidati.splice(index, 1);
      }
    }
  
    if (liquidato.altraParte && liquidato.altraParte.id) {
        const index = this.arrayLiquidati.findIndex(el => el.altraParte && el.altraParte.id === liquidato.altraParte.id);
        if (index !== -1) {
            this.arrayLiquidati.splice(index, 1);
        }
    }
  
    if (liquidato.legaleIncaricato && liquidato.legaleIncaricato.id) {
        const index = this.arrayLiquidati.findIndex(el => el.legaleIncaricato && el.legaleIncaricato.id === liquidato.legaleIncaricato.id);
        if (index !== -1) {
            this.arrayLiquidati.splice(index, 1);
        }
    } 
      
    
    if (this.arrayLiquidati.length === 0) {
      this.isDefault = false;
    }
  }

  ripartizioneEquaLiquidati() {
    if (this.isModifica) {
      this.arrayLiquidati = [];
    }
    this.tuttiISoggetti = [];
      if (this.controparteOptions.length > 0) {
      this.controparteOptions.forEach(el => {
        let liquidato = { ...this.request };
        liquidato.controparte = el;
        /*let liquidato = new SezioneEsitiLiquidatiAdapter(new Liquidato()).liquidato;
        liquidato.dataLiquidato = this.request.dataLiquidato;
        liquidato.tipoLiquidato = this.request.tipoLiquidato;
        liquidato.ripartizioneEqua = this.request.ripartizioneEqua;
        liquidato.societa = this.request.societa;
        liquidato.controparte = el;
        liquidato.importoLiquidato.importo = (this.request.importoLiquidato.importo) ? Number(this.request.importoLiquidato.importo) / this.controparteOptions.length : null;
        liquidato.importoLiquidato.interessi = (this.request.importoLiquidato.interessi) ? Number(this.request.importoLiquidato.interessi) / this.controparteOptions.length : 0;
        liquidato.importoLiquidato.sanzioni = (this.request.importoLiquidato.sanzioni) ? Number(this.request.importoLiquidato.sanzioni) / this.controparteOptions.length : 0;
        liquidato.costoGestioneLiquidato.iva = this.request.costoGestioneLiquidato.iva;
        liquidato.costoGestioneLiquidato.cpa = this.request.costoGestioneLiquidato.cpa;
        liquidato.costoGestioneLiquidato.flagRitenutaAcconto = this.request.costoGestioneLiquidato.flagRitenutaAcconto;
        liquidato.costoGestioneLiquidato.compenso = (this.request.costoGestioneLiquidato.compenso) ? Number(this.request.costoGestioneLiquidato.compenso) / this.controparteOptions.length : 0;
        liquidato.altroImportoLiquidato.speseRegistrazione = (this.request.altroImportoLiquidato.speseRegistrazione) ? Number(this.request.altroImportoLiquidato.speseRegistrazione) / this.controparteOptions.length : 0;
        liquidato.altroImportoLiquidato.contributoUnificato = (this.request.altroImportoLiquidato.contributoUnificato) ? Number(this.request.altroImportoLiquidato.contributoUnificato) / this.controparteOptions.length : 0;
        liquidato.altroImportoLiquidato.altroImporto = (this.request.altroImportoLiquidato.altroImporto) ? Number(this.request.altroImportoLiquidato.altroImporto) / this.controparteOptions.length : 0;
        liquidato.altroImportoLiquidato.rimborsoTerzoPignorato = (this.request.altroImportoLiquidato.rimborsoTerzoPignorato) ? Number(this.request.altroImportoLiquidato.rimborsoTerzoPignorato) / this.controparteOptions.length : 0;*/
        this.arrayLiquidati.push(liquidato);
      });
    }
    if (this.altreParti.length > 0) {
      this.altreParti.forEach(el => {
        let liquidato = { ...this.request };
        liquidato.altraParte = el;
        this.arrayLiquidati.push(liquidato);
      });
    }
    if (this.legali.length > 0) {
      this.legali.forEach(el => {
        let liquidato = { ...this.request };
        liquidato.legaleIncaricato = el;
        this.arrayLiquidati.push(liquidato);
      });
    }
    /*if(this.isModificaSezioneLiquidati){
      this.liquidatiReset.forEach(liquidato => {
        this.arrayLiquidati.forEach(l => {
          l.id = liquidato.id;
          if(l.controparte.id === liquidato.controparte.id){
            if(liquidato.importoLiquidato)
              l.importoLiquidato.id = liquidato.importoLiquidato.id;
            if(liquidato.altroImportoLiquidato) l.altroImportoLiquidato.id = liquidato.altroImportoLiquidato.id;
            if(liquidato.costoGestioneLiquidato) l.costoGestioneLiquidato.id = liquidato.costoGestioneLiquidato.id;
          }
        })
      })
    }*/
  }


  approssimaImporto(importo: number): number {
    let num = importo;
    return Math.trunc(100 * num) / 100;
  }

  approssimaTotale(importo): number {
    let num = Number(importo);
    return (Math.abs(num - Math.round(num)) < 0.1) ? Math.round(num) : num;
  }


  chiudiModale() {
    this.onReturn.emit(this.sezione);
  }

  get speseGenerali() {
    let speseGeneraliCalc = 0;
    if (this.request.costoGestioneLiquidato && this.request.costoGestioneLiquidato.compenso && this.request.costoGestioneLiquidato.speseGenerali)
      speseGeneraliCalc = +this.request.costoGestioneLiquidato.compenso * +this.request.costoGestioneLiquidato.speseGenerali / 100;
    return speseGeneraliCalc
  }


  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args)
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }

  ripartisci(tot) {
    let string = tot.toString().replace(',', '.');
    let parsed: number = Number(string)
    let soggettiTot = [...this.controparteOptions, ...this.altreParti, ...this.legali];  
    return parsed / soggettiTot.length;
  }
}
